(() => {
  const name = 'historyHandler';

  App.common = App.common || {};

  App.common[name] = (() => {
    let ignore = false;
    let delayedIgnore = false;
    let currentHash = '';
    let stateList = '';

    const noStateFallback = () => {
      if (/#.*\?{1}/.test(window.location.hash)) {
        const { parseStateObject, setFilters } = App.productListPageFilters.filters;
        setFilters(parseStateObject());
      }
    };

    const executeFunctionByName = (functionNameString, context, args) => {
      const namespaces = functionNameString.split('.');
      const func = namespaces.pop();
      let module = context;
      namespaces.forEach((namespace) => {
        module = module[namespace] || {};
      });
      if (typeof module[func] === 'function') {
        module[func].apply(context, args);
      }
    };

    const updateState = (event) => {
      let state = '';
      if (ignore) {
        ignore = false;
        currentHash = window.location.hash;
        return;
      }

      if (event) {
        if (event.state) {
          executeFunctionByName(event.state.callback, window, event.state.arguments);
        }
      } else {
        currentHash = window.location.hash;
        state = encodeURIComponent(currentHash.replace(/^#?/, '#'));
        if (stateList[state]) {
          executeFunctionByName(stateList[state].callback, window, stateList[state].arguments);
        } else {
          noStateFallback();
        }
      }
    };

    const checkHash = () => {
      if (window.location.hash !== currentHash) {
        if (ignore !== delayedIgnore) {
          ignore = delayedIgnore;
          updateState();
          ignore = !ignore;
        } else {
          updateState();
        }
      }
      delayedIgnore = ignore;
      setTimeout(checkHash, 100);
    };

    const transformObjArgumentsToArray = (obj) => {
      if (!$.isArray(obj.arguments)) {
        // eslint-disable-next-line no-param-reassign
        obj.arguments = [obj.arguments];
      }
    };

    /**
     * Event.state in window.onpopstate function refers to the second last state that was pushed.
     * To make event.state not to be null it's needed to push state at least twice.
     * It's better to use replaceState with the current state upon load,
     * instead of calling pushState twice, which adds 2 entries to history.
     */
    const setState = (obj, url) => {
      transformObjArgumentsToArray(obj);
      if (window.history.replaceState) {
        window.history.replaceState(obj, '', url);
        window.addEventListener('popstate', updateState);
      } else {
        stateList = ($.parseJSON(decodeURIComponent(App.global.isSessionStorageSupported()
          ? window.sessionStorage.getItem('historyHandlerStates')
          : (document.cookie.match(/hstryHndlrStates=.+:END/) || [''])[0].replace(/hstryHndlrStates=|:END/g, '')))) || {};
        stateList[encodeURIComponent(`#${url}`)] = obj;
        checkHash();
      }
      App.common.historyHandler.initialized = true;
    };

    const createHashState = (obj, url) => {
      currentHash = window.location.hash;
      stateList[encodeURIComponent(`#${url}`)] = obj;
      if (App.global.isSessionStorageSupported()) {
        window.sessionStorage.setItem('historyHandlerStates', encodeURIComponent(JSON.stringify(stateList)));
      } else {
        document.cookie = `hstryHndlrStates=${encodeURIComponent(JSON.stringify(stateList))}:END`;
      }
    };

    const pushState = (obj, url) => {
      transformObjArgumentsToArray(obj);
      if (window.history.pushState) {
        window.history.pushState(obj, '', url);
      } else {
        window.location.hash = url;
        createHashState(obj, url);
      }
      ignore = false;
      delayedIgnore = false;
    };

    const replaceState = (obj, url) => {
      transformObjArgumentsToArray(obj);
      if (window.history.replaceState) {
        window.history.replaceState(obj, '', url);
      } else {
        delete stateList[encodeURIComponent(currentHash.replace(/^#?/, '#'))];
        window.location.replace(`#${url}`);
        createHashState(obj, url);
      }
      ignore = false;
      delayedIgnore = false;
    };

    return {
      pushState,
      replaceState,
      setState,
    };
  })();
})();
